import { Box } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Loading } from '@/components/Loading'
import { Note } from '@/components/Note'
import { Steps } from '@/components/Steps'
import { WizzardHeader } from '@/components/WizzardHeader'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useMeetingRecord } from '@/context/MeetingRecordProvider'
import { useSelectedOffersAddonContext } from '@/context/SelectedOffersAddonProvider'
import { useGetInsurances } from '@/hooks/useInsuranceParams'
import { useGetAvailableAddonOffers } from '@/hooks/useOfferAddon'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'

import { Step4 } from './Step4'

export const Step4Wrapper = () => {
  const navigate = useNavigate()
  const [noteText, setNoteText] = useState<string | undefined>(undefined)

  const [isLoading, setIsLoading] = useState(true)

  const {
    insuranceParams,
    insuranceParamsId: paramsId,
    isContracted,
    isFetchingData,
  } = useInsuranceParams()
  const { addonOffers, refetch: refetchAddonOffers } =
    useSelectedOffersAddonContext()

  const {
    mutateAsync: getAvailableAddonOffers,
    data: dataAvailableAddonOffers,
    isLoading: isLoadingGetOffers,
  } = useGetAvailableAddonOffers()
  const availableAddonOffers = dataAvailableAddonOffers?.data ?? []

  useEffect(() => {
    refetchAddonOffers({})
    getAvailableAddonOffers({ paramsId: paramsId! })
  }, [])

  const { refetch, meetingRecord } = useMeetingRecord()

  const getResultsEnabled = (addonOffers?.length ?? 0) > 0
  const results = useGetInsurances(addonOffers?.map((x) => x.offerId) ?? [])

  const allResultsLoaded =
    results.filter((x) => !x.isLoading && x.isFetched).length ==
    addonOffers.length && getResultsEnabled

  useEffect(() => {
    if (allResultsLoaded && meetingRecord && availableAddonOffers.length > 0)
      setIsLoading(false)
  }, [allResultsLoaded, meetingRecord, availableAddonOffers.length])

  useEffect(() => {
    if (
      !isContracted &&
      !insuranceParams!.generalParams.selectedOfferId &&
      !((insuranceParams!.generalParams.lastWizardStep ?? 0) >= 4) &&
      !isFetchingData
    ) {
      navigate(`/extra/steps/2/${paramsId}`)
      return
    } else {
      refetch()
    }
  }, [])

  useEffect(() => {
    if (addonOffers.length > 0) results.forEach((r) => r.refetch())
  }, [addonOffers.length])

  return (
    <PageWrapper
      header={<WizzardHeader />}
      steps={<Steps />}
      sidebar={<Sidebar />}
      contentProps={{
        sx: {
          pt: { base: 0, md: 0 },
        },
      }}
    >
      {noteText && noteText !== '' && (
        <Note
          date="11.10.2021 14:35"
          text={noteText}
          onChange={(text) => setNoteText(text)}
        />
      )}

      <Box sx={{ pt: { base: 0, md: !noteText ? 8 : 0 } }}>
        {isLoading && <Loading large={true} />}

        {!isLoading && !isLoadingGetOffers && meetingRecord && (
          <Step4 availableAddonOffers={availableAddonOffers} />
        )}
      </Box>
    </PageWrapper>
  )
}
